import { i18nCaReasonCodes } from 'models/caReasonCodes';
import { ContextActions } from 'utils/constants';

const {
  CA_EAI_CREATE_PARTY,
  CA_EAI_EDIT_PARTY,
  CA_EAI_DELETE_PARTY,
  CA_EAI_CREATE_MEMBER_ACCOUNT,
  CA_EAI_EDIT_MEMBER_ACCOUNT,
  CA_EAI_EDIT_MARKET_PARTICIPANT,
  CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL,
  CA_EAI_DISABLE_MEMBER_ACCOUNT,
  CA_EAI_RESTORE_MEMBER_ACCOUNT,
  CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT,
  CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT,
  CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS,
  CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS,
  CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS,
  CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS,
  CA_EAI_UPLOAD_DAMAS_CREDENTIALS,
  CA_EAI_CREATE_USER,
  CA_EAI_RESET_USER_PASSWORD,
  CA_EAI_BLOCK_USER,
  CA_EAI_UNBLOCK_USER,
  CA_EAI_EDIT_USER_USERNAME,
  CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT,
  CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT,
  CA_EAI_USER_ASSIGN_ROLE,
  CA_EAI_USER_UNASSIGN_ROLE,
  CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT,
  CA_EAI_CREATE_DELIVERY_POINT,
  CA_EAI_EDIT_DELIVERY_POINT_GDS,
  CA_EAI_EDIT_BALANCE_GROUP,
  CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS,
  CA_EAI_EDIT_DEVICE,
  CA_EAI_REMOVE_DEVICE,
  CA_EAI_CHANGE_DEVICE_GDS,
  CA_EAI_EDIT_DEVICE_CHARACTERISTICS,
  CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP,
  CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP,
  CA_EAI_CREATE_DEVICE,
  CA_EAI_CREATE_DELIVERY_CONTRACT,
  CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC
} = ContextActions.EAI;

const {
  CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN,
  CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN,
  CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN,
  CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN,
  CA_DISP_COPY_DEVICE_PRODUCTION_PLAN,
  CA_DISP_CREATE_DAILY_DIAGRAM,
  CA_DISP_EDIT_DAILY_DIAGRAM,
  CA_DISP_VALIDATE_DAILY_DIAGRAM,
  CA_DISP_ACCEPT_DAILY_DIAGRAM,
  CA_DISP_EXPORT_DAILY_DIAGRAM,
  CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION,
  CA_DISP_CREATE_OPERATION_EVENT,
  CA_DISP_EDIT_OPERATION_EVENT,
  CA_DISP_CANCEL_OPERATION_EVENT,
  CA_DISP_DELETE_OPERATION_EVENT,
  CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION,
  CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION
} = ContextActions.DISPATCHER;

export const caReasonsCodesEN: i18nCaReasonCodes = {
  /* COMMON */
  UNRESOLVABLE_MARKET_PARTICIPANT_CONTEXT_FOR_SERVICE_PROVIDER:
    'It is not possible to perform the operation under the account of the service provider',
  /* COMMON */

  /* SUBJECTS */
  [CA_EAI_CREATE_PARTY]: {
    PARTY_NAME_ALREADY_EXISTS: 'The subject name already exists in the system',
    PARTY_IDENTIFIER_ALREADY_EXISTS:
      'Identification number already exists in the system'
  },
  [CA_EAI_EDIT_PARTY]: {
    EDIT_PARTY_NOT_ALLOWED:
      'You do not have the right to edit the selected subject'
  },
  [CA_EAI_DELETE_PARTY]: {
    EDIT_PARTY_NOT_ALLOWED:
      'You do not have the right to edit the selected subject',
    ACTIVE_EMS_MEMBER_ACCOUNT_FOUND_FOR_PARTY:
      'The party cannot be deleted because it has active member accounts',
    ACTIVE_DELIVERY_CONTRACT_FOUND_FOR_PARTY:
      'The party cannot be deleted because it is a contracting party in an active delivery contract'
  },
  [CA_EAI_CREATE_MEMBER_ACCOUNT]: {
    MEMBER_ACCOUNT_CREATE_FOR_PARTY_NOT_ALLOWED:
      'You do not have the right to create a user account for the selected subject',
    ALL_MEMBER_ACCOUNTS_CREATED: 'All user accounts have already been created'
  },
  [CA_EAI_EDIT_MEMBER_ACCOUNT]: {
    EDIT_MEMBER_ACCOUNT_NOT_ALLOWED:
      'You do not have the right to edit the user account for the selected subject'
  },
  [CA_EAI_EDIT_MARKET_PARTICIPANT]: {
    EDIT_MARKET_PARTICIPANT_NOT_ALLOWED:
      'You do not have the right to edit a market participant for a given user account',
    MARKET_PARTICIPANT_EIC_ALREADY_EXISTS:
      "The market participant's EIC already exists in the system"
  },
  [CA_EAI_CHANGE_MEMBER_ACCOUNT_SUBSCRIPTION_LEVEL]: {
    CHANGE_SUBSCRIPTION_LEVEL_T_NOT_ALLOWED:
      'You do not have the right to change the service levels for given subject',
    MEMBER_ACCOUNT_TYPE_NOT_ALLOWED:
      'You do not have the right to change the service levels for given user account',
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'The data of an inactive user account cannot be edited'
  },
  [CA_EAI_DISABLE_MEMBER_ACCOUNT]: {
    DISABLE_MEMBER_ACCOUNT_NOT_ALLOWED:
      "You do not have the right to invalidate an user's account for given subject",
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'The user\'s account must be in the "active" state'
  },
  [CA_EAI_RESTORE_MEMBER_ACCOUNT]: {
    RESTORE_MEMBER_ACCOUNT_NOT_ALLOWED:
      "You do not have the right to restore an user's account for given subject",
    INCORRECT_MEMBER_ACCOUNT_STATUS:
      'The user\'s account must be "inactive" or “blocked“'
  },
  [CA_EAI_CREATE_MARKET_PARTICIPANT_MEMBER_ACCOUNT]: {
    CREATE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'You do not have the right to create a market participant account for given subject',
    ACCOUNT_ALREADY_EXISTS:
      'There is already an account of the subject in the role "Market Participant"'
  },
  [CA_EAI_CREATE_SERVICE_PROVIDER_MEMBER_ACCOUNT]: {
    CREATE_MEMBER_ACCOUNT_NOT_ALLOWED:
      'You do not have the right to create a service provider account for given subject',
    ACCOUNT_ALREADY_EXISTS:
      'There is already an account of the subject in the role "Service Provider"'
  },
  [CA_EAI_UPLOAD_MARKET_PARTICIPANT_CREDENTIALS]: {
    UPLOAD_MARKET_PARTICIPANT_CREDENTIALS_NOT_ALLOWED:
      'You do not have the right to upload external services credentials for a given market participant account',
    CERTIFICATE_HAS_BAD_CONTENT_TYPE:
      'Cetriticate is not a supported X.509 type'
  },
  [CA_EAI_WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS]: {
    WITHDRAW_MARKET_PARTICIPANT_CREDENTIALS_NOT_ALLOWED:
      'You do not have the right to remove external services credentials for a given market participant account'
  },
  [CA_EAI_UPLOAD_OKTE_ISZO_CREDENTIALS]: {
    CREDENTIALS_ALREADY_EXIST:
      'OKTE ISZO credentials already exists for the given market participant',
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'You do not have the right to upload external services credentials for a given market participant account'
  },
  [CA_EAI_UPLOAD_OKTE_ISOT_CREDENTIALS]: {
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'You do not have the right to upload external services credentials for a given market participant account',
    CREDENTIALS_ALREADY_EXIST:
      'OKTE ISOT credentials already exists for the given market participant'
  },
  [CA_EAI_UPLOAD_DAMAS_CREDENTIALS]: {
    UPLOAD_TO_MARKET_PARTICIPANT_NOT_ALLOWED:
      'You do not have the right to upload external services credentials for a given market participant account',
    CREDENTIALS_ALREADY_EXIST:
      'DAMAS credentials already exists for the given market participant'
  },
  /* SUBJECTS */

  /* USERS */
  [CA_EAI_CREATE_USER]: {
    USER_EMAIL_ALREADY_EXISTS:
      'The entered e-mail address already exists in the system'
  },
  [CA_EAI_RESET_USER_PASSWORD]: {
    INCORRECT_USER_STATUS: 'User must be active'
  },
  [CA_EAI_BLOCK_USER]: {
    INCORRECT_USER_STATUS: 'User must be active'
  },
  [CA_EAI_UNBLOCK_USER]: {
    INCORRECT_USER_STATUS: 'User must be inactive'
  },
  [CA_EAI_EDIT_USER_USERNAME]: {
    USER_EMAIL_ALREADY_EXISTS:
      'The entered e-mail address already exists in the system'
  },
  [CA_EAI_USER_ASSIGN_MEMBER_ACCOUNT]: {
    USER_EDIT_NOT_ALLOWED: 'You do not have the right to assign given user',
    ASSIGNMENT_TO_CHOSEN_MEMBER_ACC_NOT_ALLOWED:
      'You do not have the right to assign a user to the given users’s account'
  },
  [CA_EAI_USER_UNASSIGN_MEMBER_ACCOUNT]: {
    USER_EDIT_NOT_ALLOWED: 'You do not have the right to assign given user',
    UNASSIGNMENT_FROM_CHOSEN_MEMBER_ACC_NOT_ALLOWED:
      'You do not have the right to assign a user to the given users’s account',
    CANNOT_UNASSIGN_MEMBER_ACC_WITH_CURRENTLY_ASSIGNED_ROLES:
      'You do not have the right to unassign a user to the given users’s account. The user has a role that you do not have the right to unassign.'
  },
  [CA_EAI_USER_ASSIGN_ROLE]: {
    USER_EDIT_NOT_ALLOWED: 'You do not have the right to assign given user',
    CANNOT_ASSIGN_REQUISITE_ROLE:
      'You do not have the right to assign the given role'
  },
  [CA_EAI_USER_UNASSIGN_ROLE]: {
    CANNOT_UNASSIGN_REQUISITE_ROLE:
      'You do not have the right to remove given role'
  },
  /* USERS */

  /* DELIVERY POINT */
  [CA_EAI_EDIT_DELIVERY_POINT_ASSIGNMENT]: {
    DELIVERY_POINT_ASSIGNMENT_VALIDITY_CONFLICT:
      'The delivery point assignment conflicts with another assignment.',
    GDS_WITH_INSTALLED_DEVICES_DEREGISTRATION_CONFLICT:
      'GDS must not have installed devices during deregistration'
  },
  [CA_EAI_CREATE_DELIVERY_POINT]: {
    DELIVERY_POINT_EIC_ALREADY_EXISTS:
      'The delivery point with the given EIC already exists in the system.'
  },
  [CA_EAI_EDIT_DELIVERY_POINT_GDS]: {
    GDS_WITH_INSTALLED_DEVICES_DEREGISTRATION_CONFLICT:
      'GDS must not have installed devices during deregistration.'
  },
  /* DELIVERY POINT */

  /* BALANCE GROUPS */
  [CA_EAI_EDIT_BALANCE_GROUP]: {
    EDIT_BALANCE_GROUP_NOT_ALLOWED:
      'You are not authorized to modify the data of this balancing group.'
  },
  [CA_EAI_LIST_BALANCE_GROUP_DELIVERY_POINTS]: {
    LIST_BALANCE_GROUP_DELIVERY_POINTS_NOT_ALLOWED:
      'You are not authorized to list the delivery points of this balancing group.'
  },
  [CA_EAI_EDIT_BALANCE_GROUP_CHARACTERISTIC]: {
    EDIT_BALANCE_GROUP_CHARACTERISTIC_NOT_ALLOWED:
      'You do not have the right to modify the characteristics of this balancing group.'
  },
  /* BALANCE GROUPS */

  /* DEVICES */
  [CA_EAI_EDIT_DEVICE]: {
    EDIT_DEVICE_NOT_ALLOWED:
      'You do not have the right to edit the given device'
  },
  [CA_EAI_REMOVE_DEVICE]: {
    DEVICE_REMOVAL_NOT_ALLOWED:
      'You do not have the right to remove the given device'
  },
  [CA_EAI_CHANGE_DEVICE_GDS]: {
    CHANGE_DEVICE_GDS_NOT_ALLOWED:
      'You do not have the right to change the communication gateway assignment of given device'
  },
  [CA_EAI_EDIT_DEVICE_CHARACTERISTICS]: {
    EDIT_DEVICE_CHARACTERISTICS_NOT_ALLOWED:
      'You do not have the right to modify the characteristics of the given device'
  },
  [CA_EAI_CREATE_DEVICE_CHARACTERISTIC_GROUP]: {
    CREATE_DEVICE_CHARACTERISTIC_GROUP_NOT_ALLOWED:
      'You do not have the right to create characteristic group for a given device'
  },
  [CA_EAI_DELETE_DEVICE_CHARACTERISTIC_GROUP]: {
    DELETE_DEVICE_CHARACTERISTIC_GROUP_NOT_ALLOWED:
      'You do not have the right to remove characteristic group for a given device'
  },
  [CA_EAI_CREATE_DEVICE]: {
    CHOSEN_DEVICE_OOM_NOT_ALLOWED:
      'You do not have the right to create a device for the given delivery point'
  },
  /* DEVICES */

  /* DELIVERY CONTRACT */
  [CA_EAI_CREATE_DELIVERY_CONTRACT]: {
    CURRENT_CONTRACTING_PARTY_NOT_INCLUDED:
      'The contractual party must be the market participant under which you are currently logged in'
  },
  /* DELIVERY CONTRACT */

  /* PRODUCTION PLANNING */
  [CA_DISP_CREATE_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'It is not possible to create a production plan for a closed business day.',
    PLAN_ALREADY_EXISTS:
      'The production plan for this business day already exists.'
  },
  [CA_DISP_EDIT_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'It is not possible to edit the production plan for a closed business day.'
  },
  [CA_DISP_CONFIRM_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'It is not possible to confirm the production plan for a closed business day.',
    PRODUCTION_PLAN_LIFECYCLE_VIOLATION:
      'Production plan state transition not allowed.',
    DEVICE_NOT_INSTALLED: 'The device is not installed.'
  },
  [CA_DISP_PROPAGATE_DEVICE_PRODUCTION_PLAN]: {
    PRODUCTION_DATE_OVERDUE:
      'It is not possible to propagate the production plan for a closed business day.',
    PRODUCTION_PLAN_LIFECYCLE_VIOLATION:
      'Production plan state transition not allowed.',
    DEVICE_NOT_INSTALLED: 'The device is not installed.',
    GDS_PLANNING_HORIZON_EXCEEDED:
      'Production can be scheduled up to 6 days into the future.'
  },
  [CA_DISP_COPY_DEVICE_PRODUCTION_PLAN]: {
    TARGET_PRODUCTION_DAY_NOT_IN_FUTURE:
      'The target business day must be in the future.',
    CREATION_OF_PRODUCTION_PLAN_NOT_ALLOWED:
      'You are not authorized to copy the production plan to the selected device.',
    PRODUCTION_PLAN_PERIODS_MISMATCH:
      'The source and target business days must have the same number of  trading periods.',
    PRODUCTION_PLAN_ALREADY_EXISTS:
      'There is already a production plan on the selected business day or range of days.'
  },
  [CA_DISP_CREATE_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_ALREADY_EXISTS:
      'The daily diagram for this business day already exists.',
    DAILY_DIAGRAM_REGISTRATION_DEADLINE_OVERDUE:
      'It is not possible to create a daily diagram for a closed business day.',
    NO_PRODUCTION_PLAN_REVISION_PROVIDED:
      'It is necessary to create at least one revision of the device production plan in this balance group.',
    NO_VALID_PRODUCTION_PLAN_REVISION_PROVIDED:
      'It is necessary to confirm at least one revision of the device production plan in this balance group.',
    PRODUCTION_PLAN_REVISION_NOT_EXISTS:
      'Invalid request to modify the daily diagram.',
    PRODUCTION_PLAN_AND_DAILY_DIAGRAM_DATE_MISMATCH:
      'Invalid request to modify the daily diagram.',
    ONLY_ONE_PRODUCTION_PLAN_REV_PER_DEVICE_ALLOWED:
      'Invalid request to modify the daily diagram.',
    INVALID_DEVICE_PRODUCTION_PLAN:
      'Invalid request to modify the daily diagram.',
    MISSING_NOMINATION_PERIOD_OR_VALUE:
      'Invalid request to modify the daily diagram.'
  },
  [CA_DISP_EDIT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_REGISTRATION_DEADLINE_OVERDUE:
      'It is not possible to edit a daily diagram for a closed business day.',
    NO_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Invalid request to modify the daily diagram.',
    NO_VALID_PRODUCTION_PLAN_REVISION_PROVIDED:
      'Invalid request to modify the daily diagram.',
    PRODUCTION_PLAN_REVISION_NOT_EXISTS:
      'Invalid request to modify the daily diagram.',
    PRODUCTION_PLAN_AND_DAILY_DIAGRAM_DATE_MISMATCH:
      'Invalid request to modify the daily diagram.',
    ONLY_ONE_PRODUCTION_PLAN_REV_PER_DEVICE_ALLOWED:
      'Invalid request to modify the daily diagram.',
    INVALID_DEVICE_PRODUCTION_PLAN:
      'Invalid request to modify the daily diagram.',
    MISSING_NOMINATION_PERIOD_OR_VALUE:
      'Invalid request to modify the daily diagram.'
  },
  [CA_DISP_VALIDATE_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_VALIDATION_FOR_BAL_GRP_NOT_ALLOWED:
      'You are not authorized to work with the daily diagram of this balancing group.'
  },
  [CA_DISP_ACCEPT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Daily diagram state transition not allowed.',
    DAILY_DIAGRAM_ACCEPT_FOR_BAL_GRP_NOT_ALLOWED:
      'You are not authorized to work with the daily diagram of this balancing group.'
  },
  [CA_DISP_EXPORT_DAILY_DIAGRAM]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Daily diagram state transition not allowed.',
    DAILY_DIAGRAM_EXPORT_FOR_BAL_GRP_NOT_ALLOWED:
      'You are not authorized to work with the daily diagram of this balancing group.'
  },
  [CA_DISP_SUBMIT_DAILY_DIAGRAM_REVISION]: {
    DAILY_DIAGRAM_INVALID_PROPAGATION_STATUS:
      'Daily diagram state transition not allowed.',
    DAILY_DIAGRAM_INVALID_SUBMISSION_DATE:
      'It is not possible to edit a daily diagram for a closed business day.',
    DAILY_DIAGRAM_CORRECTION_DEADLINE_OVERDUE:
      'It is not possible to edit a daily diagram for a closed business day.'
  },
  /* PRODUCTION PLANNING */

  /* OPERATION CALENDAR */
  [CA_DISP_CREATE_OPERATION_EVENT]: {
    CREATE_OPERATION_EVENT_FOR_OPERATION_CALENDAR_NOT_ALLOWED:
      'You are not authorized to add events of the selected device.',
    OPERATION_EVENT_END_MUST_BE_AFTER_START:
      'The end time of the event must follow the start of the event.',
    OPERATION_EVENT_START_NOT_IN_FUTURE:
      'The start of the event must be in the future.'
  },
  [CA_DISP_EDIT_OPERATION_EVENT]: {
    EDIT_OPERATION_EVENT_NOT_ALLOWED:
      'You are not authorized to edit  events of the selected device.',
    EDIT_OF_CANCELLED_EVENT_NOT_ALLOWED:
      'Editing of a canceled event is not allowed.',
    EDIT_OF_COMPLETED_EVENT_END_NOT_ALLOWED:
      'It is not possible to edit the end time of a completed event.',
    EDIT_OF_COMPLETED_EVENT_START_NOT_ALLOWED:
      'It is not possible to edit the start time of a finished event.',
    EDIT_OF_IN_PROGRESS_EVENT_START_NOT_ALLOWED:
      'It is not possible to edit the start time of an ongoing event.',
    OPERATION_EVENT_END_MUST_BE_AFTER_START:
      'The end time of the event must follow the start of the event.',
    OPERATION_EVENT_START_NOT_IN_FUTURE:
      'The start of the event must be in the future.',
    OPERATION_EVENT_END_NOT_IN_FUTURE:
      'It is not possible to adjust the end time of the event to the past.'
  },
  [CA_DISP_CANCEL_OPERATION_EVENT]: {
    OPERATION_EVENT_CANCELLATION_NOT_ALLOWED:
      'You are not authorized to cancel events of the selected device.',
    OPERATION_EVENT_ALREADY_CANCELED: 'The event has already been cancelled.'
  },
  [CA_DISP_DELETE_OPERATION_EVENT]: {
    OPERATION_EVENT_DELETION_NOT_ALLOWED:
      'You are not authorized to delete events of the selected device.'
  },
  /* OPERATION CALENDAR */

  /* RESERVED CAPACITY */
  [CA_DISP_ACCEPT_RESERVED_CAPACITY_GUARDING_ACTION]: {
    GUARDING_ACTION_ACCEPTANCE_NOT_ALLOWED:
      'You do not have the right to accept the given guarding action',
    GUARDING_ACTION_VALIDITY_EXPIRED:
      'The guarding action you are trying to update has expired',
    GUARDING_ACTION_UPDATE_REQUIRES_ISSUED_STATE:
      'The guarding action must be in the "Issued" status to perform the given operation',
    GUARDING_ACTION_HAS_STARTED:
      'It is not possible to accept an action whose start time is in the past.'
  },
  [CA_DISP_REJECT_RESERVED_CAPACITY_GUARDING_ACTION]: {
    GUARDING_ACTION_REJECT_NOT_ALLOWED:
      'You do not have the right to reject the given guarding action',
    GUARDING_ACTION_VALIDITY_EXPIRED:
      'The guarding action you are trying to update has expired',
    GUARDING_ACTION_UPDATE_REQUIRES_ISSUED_STATE:
      'The guarding action must be in the "Issued" status to perform the given operation'
  }
  /* RESERVED CAPACITY */
};
